import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlService } from './url.service';
import { SolutionInstanceDto } from 'app/@types/dto/solution-instance-dto.model';
import { SolutionRelevantResultsDto } from 'app/@types/dto/solution-relevant-results-dto.model';

@Injectable({
    providedIn: 'root',
})
export class SolutionHttpService {
    constructor(private http: HttpClient, private urlService: UrlService) {}

    getSolutions(orgId: string, questionnaireId: string): Observable<SolutionInstanceDto[]> {
        return this.http.get<SolutionInstanceDto[]>(this.urlService.getSolutions(orgId, questionnaireId));
    }

    computeReduction(orgId: string, solutionInstance: SolutionInstanceDto): Observable<number> {
        return this.http.post<number>(this.urlService.getComputeReductionUrl(orgId), solutionInstance);
    }

    createSolutionInstance(orgId: string, si: SolutionInstanceDto): Observable<SolutionInstanceDto> {
        return this.http.post<SolutionInstanceDto>(this.urlService.getCreateUpdateSolutionInstanceUrl(orgId), si);
    }

    updateSolutionInstance(orgId: string, si: SolutionInstanceDto): Observable<SolutionInstanceDto> {
        return this.http.put<SolutionInstanceDto>(this.urlService.getCreateUpdateSolutionInstanceUrl(orgId), si);
    }

    updateAllSolutionInstance(
        orgId: string,
        questionnaireId: string,
    ): Observable<Map<string, SolutionRelevantResultsDto>> {
        return this.http.put<Map<string, SolutionRelevantResultsDto>>(
            this.urlService.updateAllSolutionInstanceUrl(orgId, questionnaireId),
            {},
        );
    }

    delete(orgId: string, si: SolutionInstanceDto): Observable<boolean> {
        return this.http.delete<boolean>(
            this.urlService.deleteSolutionInstance(orgId, si.questionnaireId, si.solutionTemplateCode),
        );
    }
}
